module.exports = "<div *ngIf=\"entityIdDetails != null\">\n  <div *ngIf=\"entityIdDetails.isClient\">\n    <entity-details-client [entityIdDetails]=\"entityIdDetails\"></entity-details-client>\n  </div>\n  <div *ngIf=\"entityIdDetails.isOrg\">\n    <entity-details-org [entityIdDetails]=\"entityIdDetails\"></entity-details-org>\n  </div>\n  <div *ngIf=\"entityIdDetails.isPerson\">\n    <entity-details-person [entityIdDetails]=\"entityIdDetails\"></entity-details-person>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/details/entity-details.component.html
// module id = 2202
// module chunks = 0